<template>
    <el-dialog title="身份信息验证" :visible.sync="dialogVisible"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               :show-close="false"
               width="40%"
               top="5vh"
               :before-close="handleClose" append-to-body>
        <div style="text-align: center;color: red; font-weight: bold; font-size: 1.1em; margin-bottom: 10px;">
            请考生进行人脸核验。如有疑问请联系监考人员
        </div>
        <div style="text-align: center; font-size: 1.2em; font-weight: bold; margin-bottom: 10px;">
            {{ userBaseMsg }}
        </div>
        <div class="camera-container">
            <div class="video-section">
                <div class="video-wrapper">
                    <video v-show="streamActive" ref="videoPlayer" class="video-stream" autoplay playsinline></video>
                    <div v-show="!streamActive" class="placeholder">
                        <i class="fas fa-video-slash"></i>
                        <p>摄像头未激活</p>
                    </div>
                </div>
            </div>
            <div :class="['controls-message', statusType]">
                {{ statusMessage }}
            </div>
        </div>
        <div class="controls">
            <el-button @click="captureOptimizedPhoto" :disabled="!streamActive" :loading="verifyChecking" type="primary" size="medium">开始验证
            </el-button>
            <el-button v-if="showRetryButton" @click="retryAccess" type="warning" size="medium">重试访问</el-button>
        </div>
    </el-dialog>
</template>

<script>
import {id3MetaVerify} from '@/api/aliyun-verify'
import {base64ToFile} from '@/utils/file-utils'
import {commonUpload} from '@/api/file-manager'
import {getCurrentUserInfo} from '@/api/user'
import {checkFaceManualProcessResult} from '@/api/invigilate'
import DeviceInfo from "@/utils/deviceInfo";
import HttpStatus from "@/utils/httpStatus";

/**
 * 三要素身份校验
 */
export default {
    name: "CommonFaceCheckDialog",
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        checkType: {
            type: String,
            default: 'examinee'
        },
        checkItem: {
            type: Object,
            default: () => {
                return {}
            }
        }
    },
    data() {
        return {
            dialogVisible: false,
            // 视频流
            stream: null,
            // 视频流已激活
            streamActive: false,
            // 状态消息
            statusMessage: '确保头像在画面中后，点击开始验证',
            // 状态类型
            statusType: '',
            // 显示重试按钮
            showRetryButton: false,
            // 拍摄的照片
            capturedImage: null,
            // 校验中
            verifyChecking: false,
            // 用户信息
            userInfo: {},
            waitProcessInterval: null,
        };
    },
    computed: {
        userBaseMsg() {
            if (this.checkType === 'examinee') {
                return (this.checkItem && this.checkItem.id) ? (this.checkItem.examineeName + ' ' + this.checkItem.examineeIdcard) : '';
            }
            if (this.checkType === 'reviewer') {
                return (this.userInfo && this.userInfo.userId) ? (this.userInfo.realname + ' ' + this.userInfo.idCardNo) : '';
            }
        },
    },
    created() {
        this.dialogVisible = this.visible
        if (this.checkType === 'reviewer') {
            this.getCurrentUserInfo()
        }
    },
    mounted() {
        setTimeout(() => {
            this.startCamera()
        }, 1000)
    },
    methods: {
        // 上传照片并完成验证
        uploadFaceImg(base64Image) {
            const file = base64ToFile(base64Image, 'faceImg.jpg');
            const formData = new FormData();
            formData.append('file', file);
            commonUpload(formData).then(res => {
                if (res.status === 200) {
                    let faceImgUrl = window.location.origin + res.data.uri
                    let data = {
                        examId: this.checkItem.exam.id,
                        checkType: this.checkType,
                        faceImgUrl: faceImgUrl,
                        authRecordId: window.localStorage.getItem("faceVerifyRecordId-" + this.checkItem.id),
                        deviceEnv: this.getEnvMsg(),
                    }
                    id3MetaVerify(data).then(checkRes => {
                        if (checkRes.data.checkResult) {
                            this.showSuccess(checkRes.data.msg)
                            setTimeout(() => {
                                this.verifyChecking = false
                                this.$emit("success", checkRes.data.authRecordId)
                            }, 2500)
                        } else {
                            //校验不通过时，记录校验记录ID,用于下次请求回传
                            window.localStorage.setItem("faceVerifyRecordId-" + this.checkItem.id, checkRes.data.authRecordId)
                            this.showError(checkRes.data.msg)
                            this.verifyChecking = false
                            if (this.waitProcessInterval == null) {
                                this.waitProcessInterval = setInterval(() => {
                                    checkFaceManualProcessResult(this.checkItem.exam.id, this.checkType).then(checkRes => {
                                        if (checkRes.status === HttpStatus.OK && checkRes.data === true) {
                                            this.$message.success("人工核验通过")
                                            this.verifyChecking = false
                                            this.$emit("success", checkRes.data.authRecordId)
                                        }
                                    })
                                }, 3000)
                            }
                        }
                    }).catch(err => {
                        this.showError(checkRes.message)
                        this.verifyChecking = false
                    })
                } else {
                    this.verifyChecking = false
                }
            }).catch(err => {
                this.verifyChecking = false
            })
        },
        handleClose(done) {
            this.$confirm('确认关闭？')
                    .then(_ => {
                        if (this.streamActive) {
                            this.stopCamera()
                        }
                        this.$emit('cancel')
                        done();
                    })
                    .catch(_ => {
                    });
        },
        async startCamera() {
            this.clearStatus()
            try {
                // 请求高质量摄像头访问权限
                this.stream = await navigator.mediaDevices.getUserMedia({
                    video: {
                        facingMode: 'user',
                        width: {ideal: 960},
                        height: {ideal: 720},
                        frameRate: {ideal: 30}
                    },
                    audio: false
                })
                // 将视频流绑定到video元素
                this.$refs.videoPlayer.srcObject = this.stream
                this.streamActive = true
                this.showSuccess('确保头像在画面中后，点击开始验证！')
                this.showRetryButton = false
            } catch (error) {
                console.error('摄像头访问错误:', error)
                this.handleCameraError(error)
            }
        },

        stopCamera() {
            if (this.stream) {
                const tracks = this.stream.getTracks()
                tracks.forEach(track => track.stop())
                this.stream = null
            }

            this.streamActive = false
            this.showSuccess('摄像头已关闭')
            this.showRetryButton = true
        },
        captureOptimizedPhoto() {
            if (!this.streamActive) return
            this.verifyChecking = true;
            try {
                // 创建canvas用于拍照
                const canvas = document.createElement('canvas')
                const video = this.$refs.videoPlayer
                const context = canvas.getContext('2d')
                // 获取视频实际尺寸
                const videoWidth = video.videoWidth
                const videoHeight = video.videoHeight
                // 计算目标尺寸（保持高分辨率，固定为竖屏720x960比例）
                let targetWidth, targetHeight
                if (videoWidth > videoHeight) {
                    // 横屏视频，保持高清晰度
                    targetWidth = 720
                    targetHeight = 960
                } else {
                    // 竖屏视频，保持高清晰度
                    targetWidth = 720
                    targetHeight = 960
                }
                canvas.width = targetWidth
                canvas.height = targetHeight
                // 计算裁剪区域（居中裁剪，保持高清晰度）
                let sourceX, sourceY, sourceWidth, sourceHeight
                if (videoWidth / videoHeight > targetWidth / targetHeight) {
                    // 视频更宽，裁剪左右边缘
                    sourceHeight = videoHeight
                    sourceWidth = Math.round(videoHeight * targetWidth / targetHeight)
                    sourceX = Math.round((videoWidth - sourceWidth) / 2)
                    sourceY = 0
                } else {
                    // 视频更高，裁剪上下边缘
                    sourceWidth = videoWidth
                    sourceHeight = Math.round(videoWidth * targetHeight / targetWidth)
                    sourceX = 0
                    sourceY = Math.round((videoHeight - sourceHeight) / 2)
                }
                // 使用高质量绘制算法
                context.imageSmoothingEnabled = true
                context.imageSmoothingQuality = 'high'
                // 绘制裁剪后的视频帧到canvas（保持高清晰度）
                context.drawImage(video, sourceX, sourceY, sourceWidth, sourceHeight, 0, 0, targetWidth, targetHeight)
                // 高质量压缩（质量0.95以上保持清晰度）
                let quality = 0.95
                let dataUrl = canvas.toDataURL('image/jpeg', quality)
                // 确保文件大小小于1MB（必要时才降低质量）
                while (dataUrl.length > 1024 * 1024 && quality > 0.90) {
                    quality -= 0.02
                    dataUrl = canvas.toDataURL('image/jpeg', quality)
                }
                this.capturedImage = dataUrl
                // this.showSuccess(`照片已拍摄 (${this.formatBytes(dataUrl.length)})`)
                this.uploadFaceImg(dataUrl)
            } catch (error) {
                console.error('人脸采集失败:', error)
                this.showError('人脸采集异常，请重试')
                this.verifyChecking = false
            }
        },
        handleCameraError(error) {
            if (error.name === 'NotAllowedError' ||
                    error.name === 'PermissionDeniedError') {
                this.showError('摄像头访问被拒绝，请允许访问权限')
                this.showRetryButton = true
            } else if (error.name === 'NotFoundError' ||
                    error.name === 'OverconstrainedError') {
                this.showError('未检测到摄像头设备')
                this.showRetryButton = true
            } else if (error.name === 'NotReadableError') {
                this.showError('摄像头正被其他应用程序占用')
                this.showRetryButton = true
            } else {
                this.showError('无法访问摄像头')
                this.showRetryButton = true
            }
        },
        retryAccess() {
            this.startCamera()
        },
        showError(message) {
            this.statusMessage = message
            this.statusType = 'status-error'
        },
        showSuccess(message) {
            this.statusMessage = message
            this.statusType = 'status-success'
        },
        showWarning(message) {
            this.statusMessage = message
            this.statusType = 'status-warning'
        },
        clearStatus() {
            this.statusMessage = '确保头像在画面中后，点击开始验证'
            this.statusType = ''
        },
        formatBytes(bytes) {
            if (bytes < 1024) return bytes + ' bytes'
            else if (bytes < 1048576) return (bytes / 1024).toFixed(1) + ' KB'
            else return (bytes / 1048576).toFixed(1) + ' MB'
        },
        getCurrentUserInfo() {
            getCurrentUserInfo().then(res => {
                this.userInfo = res.data
            })
        },
        getEnvMsg() {
            let device = DeviceInfo.getDeviceInfo()
            let list = []
            if (device) {
                if (device.os && device.os.name && device.os.version) {
                    list.push(device.os.name + ' ' + device.os.version)
                }

                if (device.browser && device.browser.name && device.browser.version) {
                    list.push(device.browser.name + ' ' + device.browser.version)
                }

                if (device.screen && device.screen.width && device.screen.height) {
                    list.push(device.screen.width + 'x' + device.screen.height)
                }
            }
            return list.join("/")
        }
    },
    beforeDestroy() {
        // 组件销毁前清理资源
        if (this.stream) {
            const tracks = this.stream.getTracks()
            tracks.forEach(track => track.stop())
        }
        if (this.waitProcessInterval) {
            clearInterval(this.waitProcessInterval)
        }
    }
}
</script>

<style scoped>
.camera-container {
    background: white;
    border-radius: 20px;
    box-shadow: 0 15px 35px rgba(0, 0, 0, 0.2);
    overflow: hidden;
    padding: 0px;
    text-align: center;
    max-width: 336px;
    margin: 0px auto;
}

.video-section {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    margin-bottom: 15px;
}

.video-wrapper {
    flex: 1;
    min-width: 300px;
    position: relative;
    padding-top: 448px;
    border-radius: 15px;
    overflow: hidden;
    background: #000;
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
}

.video-stream {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.placeholder {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: #aaa;
    background: #f5f5f5;
}

.placeholder i {
    font-size: 3rem;
    margin-bottom: 15px;
    color: #ccc;
}

.controls-message {
    display: flex;
    justify-content: center;
    gap: 15px;
    flex-wrap: wrap;
    margin: 10px;
}

.controls {
    display: flex;
    justify-content: center;
    gap: 15px;
    flex-wrap: wrap;
    margin: 15px;
}

.status-message {
    padding: 15px;
    border-radius: 10px;
    margin: 20px 0;
    font-weight: 500;
    display: none;
}

.status-error {
    background: #ffebee;
    color: #c62828;
    border: 1px solid #ffcdd2;
    display: block;
}

.status-success {
    background: #e8f5e9;
    color: #2e7d32;
    border: 1px solid #c8e6c9;
    display: block;
}

.status-warning {
    background: #fff8e1;
    color: #f57f17;
    border: 1px solid #ffecb3;
    display: block;
}

@media (max-width: 336px) {
    .video-section {
        flex-direction: column;
    }

    .video-wrapper {
        min-width: 100%;
        padding-top: 100%;
    }
}

</style>